<template>
  <div class="el-popper capital-dropdown" :class="{'hq-capital-dropdown':HQ}" :style="{ width: '340px' }">
    <div id="confirmButton">
      <el-row style="padding-left: 13px; margin:0; padding: 10px; border-bottom: 1px solid #d8dce5" :gutter="10">
        <el-col :span='7'>
          <!-- 文本框start没有同步更新 但是number类 无法限制长度 type='number'-->
          <input class="capital-input" type="text" name="" :class="{'capital-error': (startError || compareError)}" v-model.trim="start" @focus="clearInputError" placeholder="最小" :maxlength=8 v-on:input="start=start.replace(/^0(0+)|[^\d]+/g,'')">
          <!-- <el-input  type='number'  :class="{'capital-error': (startError || compareError)}" v-model.trim="start"  v-on:input="start=start.replace(/^0(0+)|[^\d]+/g,'')" placeholder="最小" maxlength="8" :max='99999999'></el-input> -->
        </el-col>
        <el-col style="margin-top:4px;margin-left: -3px;" :span="1">-</el-col>
        <el-col :span='7'>
          <input class="capital-input" type="text" name="" :class="{'capital-error': (endError || compareError)}" v-model.trim="end" @focus="clearInputError" placeholder="最大" :maxlength=8 v-on:input="end=end.replace(/^0(0+)|[^\d]+/g,'')" >
          <!-- <el-input type='number' class="capital-input" :class="{'capital-error': (endError || compareError)}" v-model.trim="end" placeholder="最大"  maxlength="8" v-on:input="end=end.replace(/^0(0+)|[^\d]+/g,'')" :max='99999999'></el-input> -->
        </el-col>
        <el-col style="font-size: 14px; padding-left: 0;margin-top: 10px;" :span="1">万</el-col>
        <el-col :span="4" style="margin-left: 16px">
          <el-button type="primary" @click="addCustom" id='capitalSelect' :name="$route.name+'-capitalSelect'">确定</el-button>
        </el-col>
      </el-row>
      <div v-for="(item,index) in dataList" :key="index" @click="onSelect(item.key)" class="capital-item" :class="{'selected':check(item.key), 'not-allowed':initialCapital&& initialCapital!=item.key}" >
        {{item.value}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value','querystring','dataList','isSearch'],
  inject: ['select'],
  data() {
    return {
      minWidth: '',
      start: '',
      end: '',
      startDirty: false,
      endDirty: false,
      startError:false,
      endError:false,
      compareError:false,
      HQ: __VERSION === 'HQ',

    };
  },

  computed: {
    popperClass() {
      return this.$parent.popperClass;
    },
    initialCapital () {
      if (!this.querystring) return null;
      if (this.querystring.indexOf('}') != -1) {
        let form = JSON.parse(this.querystring);
        if (form.filter) {
          form.filter = JSON.parse(form.filter);
        }
        if (form.filter.registercapital != '0') {
          return form.filter.registercapital;
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  },

  watch: {
    '$parent.inputWidth'() {
      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
    },
    'select.visible'() {
      if (!this.select.visible) {
        this.startDirty = false;
        this.endDirty = false;
        this.start = '';
        this.end = '';
      } else {
        console.log('this.statb')
        let value = this.isSearch ? this.value[0]:this.value;
        if (value.indexOf(',') != -1) {
          const arr = value.split(',');
          this.start = arr[0];
          this.end = arr[1];
        }
      }
      this.clearInputError();
    },
  },

  methods: {
    checkInput(){
      let numberRE = /(^[1-9]\d{0,7}$)|(^0$)/;
      this.startError =(!numberRE.test(this.start) && this.start.trim() != '')?true:false;
      this.endError =(!numberRE.test(this.end) && this.end.trim() != '')?true:false;
      if (this.start.trim() || this.end.trim()) {
        this.compareError = parseInt(this.end) <= parseInt(this.start) ? true : false;
      } else {
        this.compareError = true;
      }
    },
    clearInputError(){
      this.startError = this.endError = this.compareError = false;
    },
    addCustom() {
      this.checkInput();
      if(!(this.startError || this.endError || this.compareError)){
        const data =
          (this.start ? this.start : '') + ',' + (this.end ? this.end : '');
        this.$emit('input', this.isSearch?[data]:data);
        this.select.visible = false;
      }
    },
    onSelect(val) {
      if(this.initialCapital&&this.initialCapital!=val){
        return
      }
      this.$emit('input', this.isSearch?[val]:val);
      this.start = '';
      this.end = '';
      this.select.visible = false;
    },
    check(val) {
      if (this.value == val) {
        return true;
      }
    }
  },

  mounted() {

    if (this.value.indexOf(',') != -1) {
      const arr = this.value.split(',');
      this.start = arr[0];
      this.end = arr[1];
    }
  }
};
</script>
<style lang="scss" scoped>
.capital-dropdown {
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.capital-item {
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #5a5e66;
  height: 34px;
  line-height: 34px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
  &.not-allowed{
    cursor: not-allowed;
    color: #999;
  }
}

.capital-item.selected {
  color: var(--theme-color);
}
.hq-capital-dropdown {
  .capital-item {
    &.selected {
      color: #337ab7;
    }
  }
}
// .capital-item.selected:after {
//   position: absolute;
//   right: 20px;
//   font-family: element-icons;
//   content: '\E611';
//   font-size: 12px;
//   font-weight: 700;
//   -webkit-font-smoothing: antialiased;
// }

.capital-item.hover,
.capital-item:hover {
  background: #f5f7fa;
}
.capital-input{
  background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
    text-align: center;
    height: 30px;
    line-height: 30px;
    &:focus{
      border-color: #46c8c8
    }
}


</style>



// WEBPACK FOOTER //
// src/components/clickSelect/capital.vue